import Promise from 'bluebird';
import Zip from 'jszip';
import zipUtils from 'jszip-utils';

import values from 'lodash/values';
import flatten from 'lodash/flatten';

export const getFiles = url => flatten(values(url));

export const downloadFile = (file, downloadFineName, isBlob = false) => {
	const link = document.createElement('a');

	link.href = isBlob ? URL.createObjectURL(file) : file;
	link.setAttribute('download', downloadFineName);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const downloadZip = filesUrl => createZip(filesUrl, downloadFile);

export const createZip = (filesUrl, callback) => {
	if (!filesUrl || !filesUrl.length) return;
	const savedZipFileName = 'files';
	const zip = new Zip();

	Promise.map(filesUrl, url => {
		return new Promise((resolve, reject) => {
			zipUtils.getBinaryContent(url, (err, data) => {
				if (err) reject(err);

				const fileName = url.split('/').pop();

				zip.file(fileName, data, {
					base64:true,
					binary:true
				});

				resolve();
			});
		});
	})
		.then(() => {
			zip.generateAsync({type:'blob'}).then(content => {
				callback(content, savedZipFileName, true);
			});
		});
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/utils.js